import { SignInForm } from "../components/Authentication/SignInForm/SignInForm";
import useAuth from "../hooks/useAuth";
export const FirebaseAuthUi = ({ children }) => {
  const { isAuth } = useAuth();
  return isAuth ? <>{children}</> : <SignInForm />;
};
